<template>
  <div class="home" v-loading="Loading" element-loading-text="Loading......" >
    <HeadComponent msg="Welcome to Your Vue.js App"/>
    <div><h1>ESG導入調查問卷</h1></div>
    <el-divider ></el-divider>
    <div>&nbsp;</div>
    <el-row :gutter="20">
      <el-col :span="24">
        <el-row :gutter="20" >
          <el-col :span="24" class="inputStyle1"><span>ESG 已為全球企業永續發展重要指標，該問捲主要為調查，宇智網通合作夥伴的ESG導入相關進程計畫的進度與成效：</span></el-col>
        </el-row>
        <el-row :gutter="20" >
          <el-col :span="1" class="inputStyle1"><span> </span></el-col>
          <el-col :span="2" class="inputStyle1"><span>廠商名稱：</span></el-col>
          <el-col :span="18">
            <el-input v-model="VendorName" type="text" placeholder="請輸入名稱" data-space-bottom="0.5rem" style="" clearable />
          </el-col>
        </el-row>
        
        <el-divider ></el-divider>
        <el-row :gutter="20" >
          <el-col :span="24" class="inputStyle1"><span>請問貴司的ESG永續報告書目前進度為何 ?：</span></el-col>
        </el-row>
        <el-row :gutter="20" >
          <el-col :span="1" class="inputStyle1"><span> </span></el-col>           
          <el-col :span="2" class="inputStyle1"><el-radio v-model="EsgRadio" label="1">已完成</el-radio></el-col>   
        </el-row>
        <el-row :gutter="20" >
          <el-col :span="1" class="inputStyle1"><span> </span></el-col>
          <el-col :span="2" class="inputStyle1 paddingStyle1"><span>完成日期：</span></el-col>        
          <el-col :span="18">
            <el-date-picker
              style="float: left;"
              v-model="FinDate"
              type="datetime"
              range-separator="至"
              start-placeholder="開始日期"
              end-placeholder="結束日期">
            </el-date-picker>
          </el-col>
        </el-row>
        <el-row :gutter="20" >
          <el-col :span="1" class="inputStyle1"><span> </span></el-col>
          <el-col :span="2" class="inputStyle2 paddingStyle1"><span>永續報告書<br>WEB連結網址：</span></el-col>
          <el-col :span="18">
            <el-input v-model="EsgWebLink" type="text" placeholder="請輸入連結網址" data-space-bottom="0.5rem" style="" clearable />
          </el-col>
        </el-row>
        <el-row :gutter="20" >
          <el-col :span="24" class="inputStyle3"><span> </span></el-col>
        </el-row>
        
        <el-row :gutter="20" >
          <el-col :span="1" class="inputStyle1"><span> </span></el-col>
          <el-col :span="2" class="inputStyle1"><el-radio v-model="EsgRadio" label="2">未完成，目前進行中。</el-radio></el-col>
          
        </el-row>
        <el-row :gutter="20" >
          <el-col :span="1" class="inputStyle1"><span> </span></el-col>
          <el-col :span="2" class="inputStyle1 paddingStyle1"><span>預計完成日：</span></el-col>        
          <el-col :span="18">
            <el-date-picker
              style="float: left;"
              v-model="FinDate"
              type="datetime"
              range-separator="至"
              start-placeholder="開始日期"
              end-placeholder="結束日期">
            </el-date-picker>
          </el-col>
        </el-row>
        <el-row :gutter="20" >
          <el-col :span="24" class="inputStyle3"><span> </span></el-col>
        </el-row>

        <el-row :gutter="20" >
          <el-col :span="1" class="inputStyle1"><span> </span></el-col>
          <el-col :span="2" class="inputStyle1"><el-radio v-model="EsgRadio" label="3">未完成，已規劃導入。</el-radio></el-col>
        </el-row>
        <el-row :gutter="20" >
          <el-col :span="1" class="inputStyle1"><span> </span></el-col>
          <el-col :span="2" class="inputStyle1 paddingStyle1"><span>預計完成日：</span></el-col>        
          <el-col :span="18">
            <el-date-picker
              style="float: left;"
              v-model="FinDate"
              type="datetime"
              range-separator="至"
              start-placeholder="開始日期"
              end-placeholder="結束日期">
            </el-date-picker>
          </el-col>
        </el-row>
        <el-row :gutter="20" >
          <el-col :span="24" class="inputStyle3"><span> </span></el-col>
        </el-row>
        
        <el-row :gutter="20" >
          <el-col :span="1" class="inputStyle1"><span> </span></el-col>
          <el-col :span="2" class="inputStyle1"><el-radio v-model="EsgRadio" label="4">近期沒導入規劃，未來有需求會導入。</el-radio></el-col>
        </el-row>
        <el-row :gutter="20" >
          <el-col :span="24" class="inputStyle3"><span> </span></el-col>
        </el-row>

        
        <el-row :gutter="20" >
          <el-col :span="1" class="inputStyle1"><span> </span></el-col>
          <el-col :span="2" class="inputStyle1"><el-radio v-model="EsgRadio" label="5">不導入。</el-radio></el-col>
        </el-row>
        <el-row :gutter="20" >
          <el-col :span="1" class="inputStyle1"><span> </span></el-col>
          <el-col :span="2" class="inputStyle1 paddingStyle1"><span>不導入原因：</span></el-col>
          <el-col :span="18">
            <el-input v-model="EsgReason" type="text" placeholder="請輸入不導入原因" data-space-bottom="0.5rem" style="" clearable />
          </el-col>
        </el-row>        
        <el-divider ></el-divider>

        <el-row :gutter="20" >
          <el-col :span="24" class="inputStyle1"><el-button type="success" @click="submitAction" plain>送出</el-button></el-col>
        </el-row>
      </el-col>
    </el-row>
    
  </div>
</template>
<style scoped>
  .inputStyle1{
    text-align: left;
    min-height: 43px;
    font-size: 14px;
    color: #606266;
    line-height: 44px;
    font-weight: 500;
  }
  .inputStyle2{
    text-align: left;
    min-height: 43px;
    font-size: 14px;
    color: #606266;
    line-height: 22px;
    font-weight: 500;
  }
  .paddingStyle1{
    padding-left: 34px !important;
  }
  .inputStyle3{
    min-height: 50px;
  }
</style>
<script>
// @ is an alias to /src
import HeadComponent from '@/components/HeadComponent.vue';
//import { sendMail,getPoInfo,seachPo,setJsonDateDecode,getVendorMail,getUsedPo,setToyyyymmdd,setDateStrToyymmdd,setDateStrToEn } from "@/api/portalAction"
//import axios from 'axios'
//import { Decimal } from 'decimal.js'
export default {
  name: 'HomeView',
  
  data () {
    return {
      Loading:false,
      VendorName: '',
      EsgRadio:'',
      FinDate:'',
      EsgWebLink:'',
      EsgReason:''
    }
  },
  watch: {
    //監聽用的
    //TestXXX: function(){      this.XXX= this.OOO+"_"+this.YYYY;    },
  },
  created: function(){
    //vue創建需要的部分
  },
  methods: {
    submitAction(){
      var v_this = this;
      v_this.Loading =true;
      console.log(v_this.VendorName,v_this.EsgRadio,v_this.FinDate,v_this.EsgWebLink,v_this.EsgReason);
      v_this.Loading =false;
    }
  },
  components: {
    HeadComponent
  }
}
</script>
